<select
  class="form-control form-control-lg"
  [formControl]="formControl"
  [class.custom-select]="props.customSelect"
  [class.is-invalid]="showError"
  [class.is-valid]="(formControl.dirty || formControl.touched) && !showError"
  [formlyAttributes]="field"
  [attr.aria-describedby]="errorId + ' ' + errorDescriptionId"
  >
  @if (props.placeholder) {
    <option [ngValue]="null">{{ props.placeholder }}</option>
  }
  @for (opt of optionsList(); track opt) {
    <option [ngValue]="opt.value" [disabled]="opt.disabled">{{ opt.label }}</option>
  }
</select>

<div id="{{ errorDescriptionId }}" class="sr-only">
  {{ valid ? 'valid input' : '' }}
  {{ invalid ? 'invalid input' : '' }}
</div>

@if (showError && !props.suppressErrors) {
  <div class="invalid-feedback alert alert-danger mt-2 d-flex" [style.display]="'block'">
    <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
    <formly-validation-message class="ms-3" [id]="id + '-error-description-id'" [field]="field"></formly-validation-message>
  </div>
}
